// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-6ad13e60]{width:100%;height:100%;background:#f7f7f7;overflow:auto}", ""]);
// Exports
module.exports = exports;
